import type { DetailField } from './types';

export const OPPORTUNITY_INFO_FIELDS: Array<DetailField> = [
  { label: 'Opportunity Owner', value: '', readOnly: true },
  { label: 'Account Name', value: 'Dream Hotel Hollywood', readOnly: true },
  { label: 'Opportunity Name', value: '', readOnly: true },
  { label: 'Second Vendor', value: '', readOnly: true },
  {
    helperText: 'Salesforce-owned identifier.',
    label: '18 Character ID',
    value: '006RF00000TFyxjYAD',
    readOnly: true,
  },
  {
    label: 'Opportunity Record Type',
    value: 'Escapes Approved',
    options: [
      { label: 'Escapes - Pre Deal Review', value: 'Escapes - Pre Deal Review' },
      { label: 'Escapes Approved', value: 'Escapes Approved' },
    ],
  },
  { label: 'Close Date', value: '', readOnly: true },
  { label: 'Contract Signed Date', value: '', readOnly: true },
  {
    label: 'Cost Price Currency',
    value: 'USD - U.S. Dollar',
    options: [
      { label: 'USD - U.S. Dollar', value: 'USD - U.S. Dollar' },
      { label: 'AUD - Australian Dollar', value: 'AUD - Australian Dollar' },
      { label: 'EUR - Euro', value: 'EUR - Euro' },
      { label: 'GBP - British Pound', value: 'GBP - British Pound' },
    ],
  },
  { label: 'Campaign/Market Manager', value: '', readOnly: true },
  {
    label: 'Includes Solo Traveler Packages',
    value: 'No',
    options: [
      { label: 'Yes', value: 'Yes' },
      { label: 'No', value: 'No' },
    ],
  },
  {
    label: 'Reason For No Solo Packages',
    multiline: true,
    value: '',
    readOnly: true,
  },
  {
    helperText: 'Derived from Deal Options rows.',
    label: 'Number of Deal Options',
    value: '30',
    readOnly: true,
  },
  { label: 'Proposal Sent Date', value: '', readOnly: true },
  { label: '# of Proposal Sent', value: '', readOnly: true },
  {
    label: 'Stage',
    value: '',
    options: [
      { label: 'Qualification', value: 'Qualification' },
      { label: 'Proposal', value: 'Proposal' },
      { label: 'Negotiation', value: 'Negotiation' },
      { label: 'Closed Won', value: 'Closed Won' },
      { label: 'Closed Lost', value: 'Closed Lost' },
    ],
  },
  {
    label: 'Campaign Type',
    value: 'FLASH - flexi nights',
    options: [
      { label: 'FLASH - standard', value: 'FLASH - standard' },
      { label: 'FLASH - flexi nights', value: 'FLASH - flexi nights' },
      { label: 'FLASH - Bundle Module', value: 'FLASH - Bundle Module' },
    ],
  },
  { label: 'Product Type', value: '', readOnly: true },
];
